// @flow
import getRebookSuggestions from './getRebookSuggestions'

// Types
import type { PlainSearchResponse } from '../../models/search'

export type AllResultFunc = () => Promise<Array<PlainSearchResponse>>
export type Options = {
  reservation_hashed_id: String,
  current_api_provider?: boolean,
}

// Utils
const getAllRebookSuggestions = (data: Options): AllResultFunc =>
  (getRebookSuggestions(data, true): any)

/**
 * Search for a trip by given reservation id with same provider.
 * Returns empty result if no trips with same provider available.
 * @param  {Object} data
 * @return {Object}
 */
export const getRebookTrip = (data: Options) =>
  getAllRebookSuggestions(data)().then((res) => {
    const firstRes = res && res.find((x) => x.results && x.results.length)
    return firstRes ? firstRes.results[0] : null
  })

export default getRebookTrip
